import Api from '@/services/Api'

export default {
    getAllTipoActivoCaract(){
        return Api().get('caracteristicaActivo/getAll')
    },
    getTipoActivoCaractByTipAct(tipoAct){
        return Api().get('caracteristicaActivo/tipoActivoCaractTipAct/'+tipoAct)
    },
    createTipoActivoCaract(datos){
        return Api().post('caracteristicaActivo/create',datos)
    },
    updateTipoActivoCaractById(datos){
        return Api().put('caracteristicaActivo/update',datos)
    },
    generaCamposCaract(datos){
        return Api().post('caracteristicaActivo/generaCamposCaract',datos)
    },
    // deleteTipoActivo(id){
    //     return Api().delete('tipoActivo/delete/'+id)
    // }
}